
import TheToolbar from './components/layout/TheToolbar/TheToolbar.vue';
import axios, { AxiosError } from 'axios';
import { SimplePokemon } from './interfaces/SimplePokemon';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
    TheToolbar,
  },
  data() {
    return {
      pokedex: [],
      isLoading: false,
      isError: false,
      errorMessage: '',
    };
  },
  created() {
    this.loadPokemon();
  },
  methods: {
    async loadPokemon() {
      this.isLoading = true;
      try {
        const response = await axios.get(
          'https://pokeapi.co/api/v2/pokemon?limit=800'
        );

        const alteredPokemons = response.data.results.map(
          (pokemon: SimplePokemon, index: number) => {
            return {
              id: index + 1,
              url: pokemon.url,
              name: pokemon.name,
            };
          }
        );

        this.pokedex = alteredPokemons;
        this.isLoading = false;
      } catch (error: unknown | Error) {
        console.log(error);
        this.isError = true;
        if (error instanceof AxiosError) {
          this.errorMessage = error.message;
        }
      }
    },
  },
});
